export default function AboutKrystal() {
  return (
    <section id="about" className="bg-white py-28 md:py-36 scroll-mt-20">
      <div className="max-w-6xl mx-auto px-6">

        {/* Section label */}
        <p className="font-sans text-xs tracking-widest2 uppercase text-ink mb-12 text-center">
          About Krystal
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-28 items-center">

          {/* Left — image with accent */}
          <div className="relative flex justify-center lg:justify-start">
            {/* Background accent block */}
            <div className="absolute top-8 left-8 w-full h-full bg-cream" style={{ maxWidth: "380px" }} />
            <div className="relative w-full max-w-sm lg:max-w-[380px]">
              <div className="overflow-hidden" style={{ aspectRatio: "3/4" }}>
                <img
                  src="https://static.readdy.ai/image/e9a4567e546d09965afddf52525e12f0/a6906f5d1129fc68ce5cae1a1cbc675f.jpeg"
                  alt="Krystal Danielle — Life Coach &amp; Guide, personal portrait"
                  className="w-full h-full object-cover object-top"
                />
              </div>

            </div>
          </div>

          {/* Right — story */}
          <div className="flex flex-col">
            <h2 className="font-serif text-4xl md:text-5xl font-light text-ink leading-snug mb-8">
              I know what it feels like<br />
              <em className="font-medium">to stand at the crossroads.</em>
            </h2>

            <div className="flex flex-col gap-6 font-sans text-base md:text-lg font-light leading-relaxed text-ink">
              <p>
                There was a season in my life where I had everything that was supposed to make sense — and yet nothing felt like mine. I was achieving, showing up, checking boxes. But quietly, I was lost.
              </p>
              <p>
                That season asked something deeper of me. I had to face my own patterns, work through internal blocks, and master the art of trusting my own intuition.
              </p>
              <p>
                Grounded in my background as a Registered Nurse, I've developed a refined ability to recognize the deeper patterns at play — the perfectionism, the weight of others' expectations, the quiet habit of second-guessing yourself. My work blends conscious awareness with deep self-trust to help you move through outdated programming, access your own clarity, and build a life or business that is profoundly, unshakeably yours.
              </p>
              <p className="font-normal text-ink/90 border-l-2 border-accent pl-5 italic font-serif text-xl md:text-2xl leading-snug">
                You didn&apos;t land here by accident. You are ready for your next move.
              </p>
            </div>

            <div className="mt-10 flex justify-center">
              <a
                href="https://calendly.com/hello-krystaldaniellecoaching/1hr"
                target="_blank"
                rel="nofollow noreferrer"
                className="group relative inline-block font-sans text-sm tracking-widest uppercase px-8 py-4 bg-ink text-white hover:bg-charcoal transition-all duration-300 cursor-pointer whitespace-nowrap overflow-hidden"
              >
                <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-accent group-hover:w-full transition-all duration-500 ease-out" />
                <span className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ background: "radial-gradient(ellipse at center, rgba(181,113,74,0.15) 0%, transparent 70%)" }} />
                <span className="relative">Reserve Your Clarity Session</span>
              </a>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}
